"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { SortDirection } from "@/entities/ISort";
import CommunityMembersTableHeaderSortableContent from "./CommunityMembersTableHeaderSortableContent";
import { CommunityMembersSortOption } from "@/enums";
export default function CommunityMembersTableHeader(t0) {
  const $ = _c(56);
  const {
    activeSort,
    sortDirection,
    isLoading,
    onSort
  } = t0;
  const [hoverOption, setHoverOption] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <th scope="col" className="tw-whitespace-nowrap tw-px-4 sm:tw-px-6 tw-py-3 tw-text-left tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">Rank</th>;
    t2 = <th scope="col" className="tw-whitespace-nowrap tw-pr-4 tw-py-3 tw-text-left tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">Profile</th>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onSort) {
    t3 = () => onSort(CommunityMembersSortOption.LEVEL);
    $[2] = onSort;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setHoverOption(CommunityMembersSortOption.LEVEL);
    t5 = () => setHoverOption(null);
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== activeSort || $[7] !== hoverOption || $[8] !== isLoading || $[9] !== sortDirection) {
    t6 = <CommunityMembersTableHeaderSortableContent sort={CommunityMembersSortOption.LEVEL} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[6] = activeSort;
    $[7] = hoverOption;
    $[8] = isLoading;
    $[9] = sortDirection;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <th scope="col" className="tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-cursor-pointer tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400" onClick={t3} onMouseEnter={t4} onMouseLeave={t5}>{t6}</th>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onSort) {
    t8 = () => onSort(CommunityMembersSortOption.TDH);
    $[14] = onSort;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t10;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setHoverOption(CommunityMembersSortOption.TDH);
    t10 = () => setHoverOption(null);
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[18] !== activeSort || $[19] !== hoverOption || $[20] !== isLoading || $[21] !== sortDirection) {
    t11 = <CommunityMembersTableHeaderSortableContent sort={CommunityMembersSortOption.TDH} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[18] = activeSort;
    $[19] = hoverOption;
    $[20] = isLoading;
    $[21] = sortDirection;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <th scope="col" className="tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-cursor-pointer tw-py-3 tw-text-right tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400" onClick={t8} onMouseEnter={t9} onMouseLeave={t10}>{t11}</th>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onSort) {
    t13 = () => onSort(CommunityMembersSortOption.REP);
    $[26] = onSort;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setHoverOption(CommunityMembersSortOption.REP);
    t15 = () => setHoverOption(null);
    $[28] = t14;
    $[29] = t15;
  } else {
    t14 = $[28];
    t15 = $[29];
  }
  let t16;
  if ($[30] !== activeSort || $[31] !== hoverOption || $[32] !== isLoading || $[33] !== sortDirection) {
    t16 = <CommunityMembersTableHeaderSortableContent sort={CommunityMembersSortOption.REP} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[30] = activeSort;
    $[31] = hoverOption;
    $[32] = isLoading;
    $[33] = sortDirection;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t16) {
    t17 = <th scope="col" className="tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-cursor-pointer tw-py-3 tw-text-right tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400" onClick={t13} onMouseEnter={t14} onMouseLeave={t15}>{t16}</th>;
    $[35] = t13;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== onSort) {
    t18 = () => onSort(CommunityMembersSortOption.NIC);
    $[38] = onSort;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setHoverOption(CommunityMembersSortOption.NIC);
    t20 = () => setHoverOption(null);
    $[40] = t19;
    $[41] = t20;
  } else {
    t19 = $[40];
    t20 = $[41];
  }
  let t21;
  if ($[42] !== activeSort || $[43] !== hoverOption || $[44] !== isLoading || $[45] !== sortDirection) {
    t21 = <CommunityMembersTableHeaderSortableContent sort={CommunityMembersSortOption.NIC} activeSort={activeSort} sortDirection={sortDirection} isLoading={isLoading} hoveringOption={hoverOption} />;
    $[42] = activeSort;
    $[43] = hoverOption;
    $[44] = isLoading;
    $[45] = sortDirection;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t18 || $[48] !== t21) {
    t22 = <th scope="col" className="tw-px-4 sm:tw-px-6 tw-whitespace-nowrap tw-group tw-cursor-pointer tw-py-3 tw-text-right tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400" onClick={t18} onMouseEnter={t19} onMouseLeave={t20}>{t21}</th>;
    $[47] = t18;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <th scope="col" className="tw-px-4 sm:tw-pr-6 tw-whitespace-nowrap tw-group tw-py-3 tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400"><span>Active</span></th>;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== t12 || $[52] !== t17 || $[53] !== t22 || $[54] !== t7) {
    t24 = <thead className="tw-bg-iron-900 tw-border-b tw-border-x-0 tw-border-t-0 tw-border-iron-700"><tr>{t1}{t2}{t7}{t12}{t17}{t22}{t23}</tr></thead>;
    $[51] = t12;
    $[52] = t17;
    $[53] = t22;
    $[54] = t7;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  return t24;
}